// ============================================================
// NIGHTLINE EXPRESS INC — editable company information
// Update the placeholder values below as details are confirmed.
// Empty strings render as "coming soon" placeholders on the site.
// ============================================================

export const COMPANY = {
    name: "NIGHTLINE EXPRESS INC",
    shortName: "Nightline Express",
    slogan: "Drivers Are People, Not Truck Numbers.",
    city: "Rochester, New York",
    region: "Western New York",
    usdot: "1772329",
    experience: "Nearly 15 Years",
    fleet: "Around 20 Trucks",

    // EDIT: add the company's real contact details below
    phone: "", // e.g. "(585) 555-0123"
    email: "admin@nightlinetruck.com",
    recruitingEmail: "", // e.g. "recruiting@nightlineexpress.com"
    address: "", // e.g. "123 Industrial Pkwy, Rochester, NY 14624"

    // EDIT: add social profile URLs when available
    social: {
        facebook: "",
        instagram: "",
        linkedin: "",
    },
};

export const IMAGES = {
    // Real Nightline truck photography — replace files in /public/images to update sitewide
    heroSunset: "/images/truck-sunset.webp",
    heroSunsetFallback: "/images/truck-sunset.jpg",
    cityRun: "/images/truck-city.webp",
    cityRunFallback: "/images/truck-city.jpg",
    yard: "/images/truck-yard.webp",
    yardFallback: "/images/truck-yard.jpg",
    dusk: "/images/truck-dusk.webp",
    duskFallback: "/images/truck-dusk.jpg",
    highway: "https://images.unsplash.com/photo-1603439944892-caf64fa98ccb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwxfHxhbWVyaWNhbiUyMGhpZ2h3YXklMjBzdW5zZXR8ZW58MHx8fHwxNzg2NjcxNjQwfDA&ixlib=rb-4.1.0&q=85",
};

export const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;
